import React, { useContext, useState, useEffect } from "react";
import { collection, query, where, onSnapshot, orderBy } from "firebase/firestore";
import { MdList } from "react-icons/md";
import { Link } from "react-router-dom";
import { SiSpinrilla } from "react-icons/si";

import {FirebaseContext} from '../services/Firebase/Context'
import TimelineItem from '../components/TimelineItem'

const VehiculeHistoryCard = ({ id, closed, fullOpacity }) => {
  const { db } = useContext(FirebaseContext)
  const [steps, setSteps] = useState([])
  const [loading, setLoading] = useState(false)
  const disabled = !id

  useEffect(() => {
    if(!id) return
    let unsubscribe = null
    setLoading(true)
    
    const q = query(collection(db, "steps"), where("recordId", "==", id), orderBy("date", 'desc'));
    setTimeout(() => {
      unsubscribe = onSnapshot(q, (querySnapshot) => {
        const steps = [];
        querySnapshot.forEach((doc) => {
          steps.push({id: doc.id, ...doc.data()});
        });
        setSteps(steps)
        setLoading(false)
      });
    }, 0)
   
    return () => {
      if (unsubscribe) unsubscribe()
    }
  }, [db, id])

  return (
    <form className="shadow-md">
      <div className={`p-4 bg-gray-100 border-t-2 border-blue-400 rounded-t-lg ${fullOpacity ? 'bg-opacity-100' : 'bg-opacity-5'}`}>
        <div className="max-w-sm mx-auto md:w-full md:mx-0">
          <div className="inline-flex items-center space-x-4">
            <MdList className="bg-blue-200 rounded-full h-10 w-10 p-2" color="white" />
              <h1 className="text-gray-600">
                Suivi du dossier
              </h1>
          </div>
        </div>
      </div>
      <div className="bg-white">
          
      {
       disabled
       ? <div className='h-72 items-center flex'>
        <MdList className="p-2 mx-auto text-gray-300" size={100}/>
       </div>
       : <>
        <div className="text-gray-500 flex-col flex items-center w-full py-5">
          <div className="flex flex-col md:grid grid-cols-12 text-gray-50">
            { steps.map((step, i) => <TimelineItem key={step.id} {...step}
              active={i === 0}
            />)}
            {
             loading && <SiSpinrilla size={18} className="mr-2 animate-spin" color='black' />
            }
          </div>
        </div>
        {
          !closed &&
          <div className="pb-4 mx-auto w-1/2">
            <Link to={`/app/interventions/${id}/update`}>
              <button className="py-2 px-4 bg-blue-600 hover:bg-blue-700 focus:ring-blue-500 focus:ring-offset-blue-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg ">
                Mettre à jour
              </button>
            </Link>
          </div>
        }
      </>
      }
      </div>
    </form>
  );
}

export default VehiculeHistoryCard
